import MovieCreationIcon from '@material-ui/icons/MovieCreation'
import LiveTvIcon from '@material-ui/icons/LiveTv'
import MusicNoteIcon from '@material-ui/icons/MusicNote'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'

export const TORRENT_CATEGORIES = [
  { key: 'movie', name: 'Movies', icon: <MovieCreationIcon /> },
  { key: 'tv', name: 'Series', icon: <LiveTvIcon /> },
  { key: 'music', name: 'Music', icon: <MusicNoteIcon /> },
  { key: 'other', name: 'Other', icon: <MoreHorizIcon /> },
]
